<template lang="pug">
  // メール変更受付画面
  #change-mail-reception
    b-card(header-tag="header")
      //b-button.ml-3.mb-2(variant="outline-secondary", :to="{name: 'ShowCustomerInfo'}") お客様情報へ
      //b-button.ml-3.mb-2(variant="outline-success") 送信する
      change-mail-form-reception(:p_mail_address = "p_mail_address")
      //b-button.ml-3.mt-2(variant="outline-secondary", :to="{name: 'ShowCustomerInfo'}") お客様情報へ
      //b-button.ml-3.mt-2(variant="outline-success") 送信する
</template>

<script>
import ChangeMailFormReception from "@/components/supportSite/ChangeMailFormReception";

export default {
  name: "ChangeMailReception",
  props: {
    p_mail_address: { type: String, required: false },
  },
  components: {
    ChangeMailFormReception
  }
}
</script>